import { combineReducers } from 'redux';
import listingPageComparison from './comparison';
import reevoo from './reevoo';
import listingPageProducts from './listingPageProducts';
import listingPageSetup from './listingPageSetup';
import listingPageBanners from './listingPageBanners';
import listingPageFilters from './listingPageFilters';
import listingPagePagination from './listingPagePagination';
import listingPageLocationSearch from './listingPageLocationSearch';
import compareProducts from './compareProducts';
import productInfo from './productInfo';
import general from './general';
import userDetails from './userDetails';
import orderSummary from './orderSummaryPage';
import productPage from './productPage';
import tradeUp from './tradeUp';
import psa from './psa';

export default combineReducers({
  listingPage: combineReducers({
    banner: listingPageBanners,
    comparison: listingPageComparison,
    products: listingPageProducts,
    pageSetup: listingPageSetup,
    pagination: listingPagePagination,
    filters: listingPageFilters,
    locationSearch: listingPageLocationSearch
  }),
  reevoo: reevoo,
  productInfo: productInfo,
  productPage: productPage,
  general: general,
  userDetails: userDetails,
  orderSummary: orderSummary,
  compareProducts: compareProducts,
  tradeUp: tradeUp,
  psa: psa
});
